import React from 'react';
import { Collapse, Typography } from 'antd';
import PropTypes from 'prop-types'; // Add this line to import PropTypes
import classname from 'classnames';
import classes from './Pannel.module.scss';

const { Panel: AntdPannel } = Collapse;

/**
 * defaultActiveKey is trick to auto expand the panel
 * @param {*} param0
 * @returns
 */
/**
 * The function `Panel` is a React component that renders a collapsible panel with a title and content,
 * with PropTypes validation for children and title props.
 * @returns The `Panel` component is being returned. It is a collapsible panel component that displays
 * a title and content. The title is optional and can be passed as a prop. The content of the panel is
 * passed as children. The component uses Ant Design's Collapse and Typography components for styling.
 * The `children` prop is required and must be a valid React node. The `title` prop is optional
 */
export default function Panel({ children, title, extra, className, contentClassName }) {
  return (
    <Collapse defaultActiveKey={['panel']} ghost collapsible="icon">
      <AntdPannel
        className={classname(classes.panel, className)}
        key="panel"
        showArrow={false}
        collapsible="icon"
        extra={extra}
        header={
          title ? (
            <Typography.Title className={classes.panelTitle}>{title}</Typography.Title>
          ) : (
            undefined
          )
        }>
        <div className={classname(classes.panelContent, contentClassName)}>{children}</div>
      </AntdPannel>
    </Collapse>
  );
}
// Add 'children' to props validation
Panel.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  extra: PropTypes.oneOfType([PropTypes.node, PropTypes.any, PropTypes.any]),
};

Panel.defaultProps = {
  title: undefined,
  className: '',
  contentClassName: '',
  extra: undefined,
};
